const regionFromCoords = (coords, delta = 0.005) => ({
  latitude: coords.latitude,
  latitudeDelta: delta,
  longitude: coords.longitude,
  longitudeDelta: delta,
})

export default regionFromCoords
